import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=6a6f5a1a&scoped=true&"
import script from "./DictItemList.vue?vue&type=script&lang=js&"
export * from "./DictItemList.vue?vue&type=script&lang=js&"
import style0 from "./DictItemList.vue?vue&type=style&index=0&id=6a6f5a1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6f5a1a",
  null
  
)

export default component.exports